import { Component, OnInit, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { ViewContainerRef, OnDestroy } from '@angular/core';
import { Branch } from '../../branch';
import { BranchService } from '../branch.service';
import { LocationService } from 'services/location.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { SettingsService } from '../../../../shared/services/settings.service';
import { TdLoadingService } from '@covalent/core/loading/services/loading.service';
import { ExportService } from '../../../../shared/services/export.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import {Utils} from '../../../../shared/utils';

@Component({
  selector: 'app-branches-list',
  templateUrl: './branches-list.component.html',
  styleUrls: ['./branches-list.component.scss']
})
export class BranchesListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  translatePipe: TranslatePipe = new TranslatePipe();

  subscriptions: Subscription[] = [];
  branches: Branch[] = [];

  allCity$: Observable<any[]>
  allCountry$: Observable<any[]>

  columns: ITdDataTableColumn[] = [
    { name: 'name', label: this.translatePipe.transform('name', this._authService.getLanguage()), tooltip: '' },
    { name: 'code', label: this.translatePipe.transform('code', this._authService.getLanguage()) },
    { name: 'company_name', label: this.translatePipe.transform('company', this._authService.getLanguage()) },
    { name: 'city_name', label: this.translatePipe.transform('city', this._authService.getLanguage()) },
    { name: 'contact_phone', label: this.translatePipe.transform('phone', this._authService.getLanguage()) },
    { name: 'contact_email', label: this.translatePipe.transform('email', this._authService.getLanguage()) }
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 5;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  selectedBranch: number = -1;
  allBranches$: Branch[];
  allCities: any = {};
  allCountries: any = {};

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _branchService: BranchService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _locationService: LocationService,
    public _authService: AuthenticationService,
    public _exportService: ExportService,
    private _viewContainerRef: ViewContainerRef,
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscriptions.push(this._branchService
      .getBranches()
      .subscribe((branches: Branch[]) => {

        if (branches && Array.isArray(branches)) {
          this.branches = branches;
        } else {
          this.branches = [];
        }
        this.filteredData = this.branches;
        this.filteredTotal = this.branches.length;
        this.filter();

        this._loadingService.resolve('loading');
      }));

    this.allCountry$ = this._locationService.getCountry();

    this.subscriptions.push(this._locationService.getCity()
      .subscribe((cities: any[]) => {
        cities.forEach(city => {
          this.allCities[city.id] = city;
        });

        // this._locationService.getCountry()
        //   .subscribe((countries: any[]) => {
        //     countries.forEach(country => {
        //       this.allCountries[country.id] = country;
        //     });
        //   });
      }));
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('branch')) {
      this._searchBox.value = this._settingsService.getSearchTerm('branch');
      this._searchBox.searchClicked();
    }
  }

  delete(): void {
    let deleteBranchesCalls = [];
    let selectedBranches = this.selectedRows;
    let branchIds = [];

    selectedBranches.forEach(br => {
      let branchId = br.id;

      branchIds.push(branchId);

      deleteBranchesCalls.push(
        this._branchService
          .deleteBranch(branchId)
          .map((res: Response) => res)
      );
    });

    Observable.forkJoin(deleteBranchesCalls).subscribe(data => {
      this._dialogService.openAlert({
        message: 'Successfully deleted ' + (selectedBranches.length > 1 ? 'multiple branches' : '') + ' branch!',
        title: 'Success',
      });

      this.branches = this.branches.filter((branch: Branch) => {
        return !~branchIds.indexOf(branch.id);
      });

      this.filter();
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
    ? TdDataTableSortingOrder.Descending
    : TdDataTableSortingOrder.Ascending;

    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('branch', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.branches;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    if (this.selectedBranch > -1) {
      let selectedBranch: number = this.selectedBranch;
      newData = newData.filter(data => {
        return data.branches && !!~data.branches.findIndex(br => {
          return selectedBranch === br.id;
        });
      });
    }

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('branch'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }


}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/branches/branches-list/branches-list.component.ts